/* eslint-disable react/no-array-index-key */
import React, { CSSProperties, FunctionComponent, ReactNode } from 'react';
import LoadingWave from '../animation/LoadingWave';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import { Container, Text } from './Button.style';

export interface Props {
  ariaLabel?: string;
  containerStyle?: CSSProperties;
  color?: string;
  hoverColor?: string;
  fontColor?: string;
  onClick?: (e: React.MouseEvent) => void;
  onMouseEnter?: (e: React.MouseEvent) => void;
  onMouseLeave?: (e: React.MouseEvent) => void;
  icon?: any;
  iconColour?: string;
  iconHoverColour?: string;
  testID?: string;
  loadingTestID?: string;
  loading?: boolean;
  maxWidth?: string;
  type?: 'button' | 'submit' | 'reset';
  hoverTextColor?: string;
  disabled?: boolean;
  disabledColor?: string;
  disabledStyling?: string;
  pulse?: boolean;
  children?: ReactNode;
  fontSize?: number;
  className?: string;
  disableClassName?: boolean;
}

const Button: FunctionComponent<Props> = (props) => {
  return (
    <Container
      aria-label={props.ariaLabel}
      $pulsing={props.pulse}
      className={[props.disableClassName ? '' : 'pp-btn', props.className].join(' ')}
      $buttonDisabled={props.disabled}
      disabled={props.disabled}
      onClick={(e) => {
        if (!props.disabled && !props.loading && props.onClick) props.onClick(e);
      }}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
      color={props.color}
      data-testid={props.testID}
      $hoverColor={props.hoverColor}
      style={props.containerStyle}
      type={props.type}
      $maxWidth={props.maxWidth}
      $hoverTextColor={props.hoverTextColor}
      $disabledColor={props.disabledColor}
      $disabledStyling={props.disabledStyling}
      $iconHoverColour={props.iconHoverColour}
      tabIndex={!props.onClick && props.type === 'button' ? -1 : undefined}
    >
      {!props.loading && (
        <>
          {props.icon && (
            <FontAwesomeIcon
              icon={props.icon}
              color={props.iconColour || 'white'}
              size={18}
              style={{ marginRight: 10 }}
            />
          )}

          <Text $fontColor={props.fontColor} className="buttonText" $fontSize={props.fontSize}>
            {props.children}
          </Text>
        </>
      )}

      {props.loading && (
        <div data-testid={props.loadingTestID || `${props.testID}Loading`}>
          <LoadingWave color="#ffffff" size={24} />
        </div>
      )}
    </Container>
  );
};

export default Button;
